import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appAvatarBgColor]'
})
export class AvatarBgColorDirective implements OnChanges {
  @Input() appAvatarBgColor: string | undefined;
  private defaultColor: string = '#6B7280';

  constructor(private el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appAvatarBgColor']) {
      this.updateBackgroundColor();
    }
  }

  private updateBackgroundColor(): void {
    const color = this.appAvatarBgColor || this.defaultColor;
    this.el.nativeElement.style.backgroundColor = color;
  }
}
